import { render } from "./dol-upload-img-list.vue?vue&type=template&id=f37b4362"
import script from "./dol-upload-img-list.vue?vue&type=script&lang=js"
export * from "./dol-upload-img-list.vue?vue&type=script&lang=js"

import "./dol-upload-img-list.vue?vue&type=style&index=0&id=f37b4362&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__